import axios from "axios";
import AuthenticationService from "@/services/AuthenticationService.js";
import router from "@/router.js";

const authAxios = axios.create();

authAxios.interceptors.request.use((config) => {

  // failsafe check... if token is expired, this isn't going to fire, so route user to /session-expired and abort request
  if (AuthenticationService.secondsUntilAccessTokenExpires() <= 0) {
    router.push("/session-expired");
    return { ...config, signal: AbortSignal.abort() };
  } 

  // look for any key of "searchCriteria" and trim it before sending along to back end
  if (config.params?.searchCriteria) config.params.searchCriteria = config.params.searchCriteria.trim();

  // append JWT to headers with each request
  config.headers.Authorization = localStorage.getItem("authTokens") ? ("Bearer " + JSON.parse(localStorage.getItem("authTokens")).access_token) : "";

  return config;

});

export default authAxios;